import { ColumnDef } from "@tanstack/react-table";
import { LineClampedTooltip } from "@/core/components/line-clamped-tooltip";
import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";
import {
  SPIFF_RULE_EVENTS,
  SPIFF_RULE_EVENTS_LABELS,
} from "@/spiff-rules/constants";
import { SpiffRuleEvent } from "@/spiff-rules/spiff-rule";
import {
  SPIFF_RULE_EVENT_TO_TRIGGER_CLASS_NAME,
  TRIGGER_CLASS_NAME_TO_LABEL,
} from "@/spiffs/constants";

interface WithDisplayIdentification {
  display_identification: string;
  trigger_event: SpiffRuleEvent;
}

const Content = ({
  displayIdentification,
  triggerEvent,
}: {
  displayIdentification: string;
  triggerEvent: SpiffRuleEvent;
}) => {
  // For placeholder spiffs (tech_generated_lead and driving_score),
  // show the event label instead of "Placeholder"
  const isPlaceholderSpiff =
    triggerEvent === SPIFF_RULE_EVENTS.tech_generated_lead ||
    triggerEvent === SPIFF_RULE_EVENTS.driving_score;

  const triggerLabel = isPlaceholderSpiff
    ? SPIFF_RULE_EVENTS_LABELS[triggerEvent]
    : TRIGGER_CLASS_NAME_TO_LABEL[
        SPIFF_RULE_EVENT_TO_TRIGGER_CLASS_NAME[triggerEvent]
      ];

  return (
    <Stack gap="xs">
      <LineClampedTooltip tooltipContent={displayIdentification}>
        {displayIdentification}
      </LineClampedTooltip>
      <Typography
        variant="captionW1"
        textColor="tertiary"
        className="font-medium"
      >
        {triggerLabel}
      </Typography>
    </Stack>
  );
};

const EventCol = <T extends WithDisplayIdentification>(): ColumnDef<T> => ({
  header: "Event",
  accessorFn: (row) => row.display_identification,
  cell: ({ row }) => (
    <Content
      displayIdentification={row.original.display_identification}
      triggerEvent={row.original.trigger_event}
    />
  ),
});

export default EventCol;
